import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Droplets } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-card/50 border-t border-border pt-16 pb-8 px-4 md:px-8">
      <div className="container-wide mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Droplets className="w-8 h-8 text-primary" />
              <div className="flex flex-col">
                <span className="font-display text-lg font-bold text-foreground leading-none">PRECISION</span>
                <span className="text-[10px] tracking-[0.3em] text-primary font-medium mt-1">VAPOUR BLASTING</span>
              </div>
            </div>
            <p className="text-muted-foreground mb-6">
              Surface restoration with vapour blasting technology. Based in Islington, Christchurch.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.facebook.com/profile.php?id=61574602346048"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-full bg-background border border-border flex items-center justify-center text-muted-foreground hover:text-primary hover:border-primary transition-all"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold mb-4 text-foreground">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-muted-foreground hover:text-primary transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-muted-foreground hover:text-primary transition-colors">About Us</Link></li>
              <li><Link to="/process" className="text-muted-foreground hover:text-primary transition-colors">Our Process</Link></li>
              <li><Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors">FAQ</Link></li>
              <li><Link to="/areas-served" className="text-muted-foreground hover:text-primary transition-colors">Areas Served</Link></li>
              <li><Link to="/vapour-blasting-vs-sandblasting" className="text-muted-foreground hover:text-primary transition-colors">Vapour Blasting vs Sandblasting</Link></li>
              <li><Link to="/vapor-blasting" className="text-muted-foreground hover:text-primary transition-colors">Vapor Blasting (US spelling)</Link></li>
              <li><Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold mb-4 text-foreground">Services</h4>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-muted-foreground hover:text-primary transition-colors">All Services</Link></li>
              <li><Link to="/services/automotive-restoration" className="text-muted-foreground hover:text-primary transition-colors">Automotive Restoration</Link></li>
              <li><Link to="/services/industrial-cleaning" className="text-muted-foreground hover:text-primary transition-colors">Industrial Cleaning</Link></li>
              <li><Link to="/services/marine-cleaning" className="text-muted-foreground hover:text-primary transition-colors">Marine Cleaning</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg font-bold mb-4 text-foreground">Contact Info</h4>
            <ul className="space-y-3 text-muted-foreground">
              <li>Unit 2, 1 Doric Way, Islington</li>
              <li>Christchurch, New Zealand</li>
              <li><a href="mailto:info@precisionvapour.co.nz" className="hover:text-primary transition-colors">info@precisionvapour.co.nz</a></li>
              <li><a href="tel:0226578662" className="hover:text-primary transition-colors">PH: 022 657 8662</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} Precision Vapour Blasting. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
